import React, { Dispatch, SetStateAction } from 'react';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';
import { StepFooter } from '../StepFooter/StepFooter';
import { Content } from '../../../../CommonComponents/OPL/StickyFooter/StickyFooter';
import { FinancialGoal } from '../../AutoAccountWorkflow.types';

interface StepContainerProps {
  isFirstStep: boolean;
  isLastStep: boolean;
  nextStep: Dispatch<SetStateAction<void>>;
  onSubmit: (e?: React.BaseSyntheticEvent) => Promise<void>;
  previousStep: Dispatch<SetStateAction<void>>;
  progress: number;
  restartWizard: Dispatch<SetStateAction<void>>;
  validateCurrentStep: () => Promise<boolean>;
  isLoading: boolean;
  showNextButton?: boolean;
  initialActiveWorkflow: FinancialGoal | null;
}

export const StepContainer: React.FC<StepContainerProps> = ({ children, ...rest }) => {
  return (
    <Box
      as="form"
      onSubmit={event => {
        // form submit invoked remotely
        event.preventDefault();
      }}
      minWidth={500}
      mt={96}
    >
      <Content>{children}</Content>

      <StepFooter {...rest} />
    </Box>
  );
};
